import { Box } from "@mui/material";
import React from "react";
import { StyledSkeleton } from "./WidgetPreview.styles";
import { formatDate } from "features/helpers/utils";
import { useOutletContext } from "react-router";

export default function TelegramPreview({ formData, disabled }) {
  const { content, sendTime } = formData;
  const [entityName] = useOutletContext();
  return (
    <Box
      height="609px"
      position="relative"
      sx={{ opacity: disabled ? 0.5 : 1 }}
    >
      <Box
        component="img"
        src={require("assets/img/telegram-bg.png")}
        sx={{
          width: "100%",
          height: "100%",
          minHeight: "609px",
          position: "absolute",
          left: 0,
          top: 0,
        }}
      />
      <Box pt="44px" pl="24px">
        <Box
          width="360px"
          position="relative"
          zIndex={1}
          bgcolor={"#fff"}
          p="18px 24px 26px"
          borderRadius="20px 20px 20px 0"
          sx={{ wordBreak: "break-all" }}
        >
          <Box color="#3B8CD1" fontSize={12} fontWeight={600} mb="2px">
            {entityName}
          </Box>
          {content || (
            <>
              <StyledSkeleton light mb="12px" />
              <StyledSkeleton light mb="12px" width="50%" />
            </>
          )}
          <Box
            position="absolute"
            bottom="8px"
            right="16px"
            fontSize={12}
            color="#8E8E93"
            fontWeight={400}
          >
            {sendTime
              ? formatDate(sendTime, { onlyTime: true })
              : formatDate(Date.now(), { onlyTime: true })}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
